export const Config = {
  storeURL: 'https://chloma.com',
}
